const common = {
  Loading: "Chargement",
  signUp: "S'inscrire",
  login: "Se connecter",
  logout: "Déconnecter",
  email: "E-mail",
  emailFormatErrorTips: "Le format de l'e-mail est incorrect",
  emailDifferentTips: "L'adresse e-mail saisie deux fois eat incohérente",
  emailRegisteredTips: "L'email est déjà enregistré",
  password: "Mot de passe",
  passwordFormatErrorTips:
    "Les mots de passe doivent comporter de 8 à 50 caractères et contenir au moins deux des catégories suivantes : chiffres, lettres ou caractères spéciaux.",
  passwordDifferentTips: "Veuillez entrer deux fois le même mot de passe",
  verificationCode: "Code de vérification",
  verificationCodeErrorTips: "Erreur de saisie du code de vérification",
  confirm: "Confirmer",
  cancel: "Annuler",
  submit: "Soumettre",
  confirmEmail: "Confirmer l'E-mail",
  formEmptyErrorTips: "Il ne peut pas être vide",
  country: "Pays / Région",
  birthday: "Anniversaire",
  anonymous: "Anonyme",
  name: "Nom",
  nameFormatErrorTips: "Le nom d'utilisateur ne doit pas dépasser 50 caractères et ne doit pas contenir de caractères spéciaux.",
  okBtn: "OK",
  serverErrorTips: "Désolé, quelque chose s'est mal passé, veuillez réessayer plus tard.",
  updateSuccessTips: "Modifié avec succès",
  authorizationExpiredErrorTips: "L'autorisation a expiré, veuillez vous reconnecter.",
  requestFrequentlyErrorTips: "Trop de demandes identiques ont été faites dans un court laps de temps, veuillez réessayer plus tard.",
  GetCode:"obtenir le code"
};

export default common;
